import axios from "../api/axios";
import useAuth from "./useAuth";
import Cookies from 'js-cookie';
import useUserStuff from "./useUserStuff";

const useLogout = () => {
    const { setAuth, auth } = useAuth();
    // const { clearUserStuff } = useUserStuff();
    const {userStuff, clearUserStuff} = useUserStuff();

    return async () => {
        const accessToken = auth?.accessToken;
        // console.log(`accessToken: ${accessToken}`);



        try {
            // const response =
                await axios('/auth/logout', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('refreshToken')||accessToken||userStuff?.accessToken} `

                },
                withCredentials: true
            });
        } catch (err) {
            console.error(err);
        }finally {
            setAuth({});
            clearUserStuff();
            Cookies.remove('refreshToken');
            localStorage.removeItem('refreshToken');
        }
    };
}

export default useLogout